import { FILTER_TYPES } from 'components/FilterPod';

const filters = () => [
  {
    title: 'نام مجموعه',
    label: 'نام مجموعه',
    keyName: 'name',
    query: 'name',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
];

export default filters;
